<template>
  <div class="orderForm" :style="{ 'background-image': 'url(' + picUrl + 'qunaer/card/banner01.png)' }">
    <p class="pageTitle">绑定手机号</p>
    <ul class="form">
      <li class="item">
        <div class="label">账号</div>
        <div class="text">{{cardNum}}</div>
      </li>
      <li class="item">
        <div class="label">手机号</div>
        <div class="text"><input type="number" placeholder="请填写乘机人本人手机号" v-model="phone" @blur="blurTo"></div>
      </li>
      <li class="item">
        <div class="label">验证码</div>
        <div class="text message">
          <input type="text" v-model="verifyCode" @blur="blurTo"/>
          <span class="message-btn" @click="sendSms">{{msgSendTxt}}</span>  
        </div>
      </li>
      <li class="buttons">
        <button class="bottom" @click="updatePhone">提交</button>
      </li>
    </ul>
  </div>
</template>

<script>
import { Toast, Dialog } from 'vant'

import { setToken, getToken, getPicUrl } from '../utils/auth'
import { getUserInfo, sendVerifyCode, bindPhone } from '../api/index'
export default {
  name: 'OrderFrom',
  components: {
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component
	},
  data() {
    return {
      picUrl: getPicUrl(),
      cardNum: '',
      phone: '',
      verifyCode: '',
      msgSendTxt: '获取验证码',
      msgSendStatus: true,
      token: ''
    }
  },
  created() {
    const that = this
    this.businessId = this.$route.params.businessId
    this.getUserInfo()
    .then(res => {
      if(res.data.code != '200'){
          throw res.data.msg
        }
        if(res.data.code == '200'){
          setToken(res.data.data.token)
          that.userInfo = res.data.data
          if(!res.data.data.userCard || !res.data.data.userCard.cardNum){
            that.$toast('会员卡不存在')
            return false
          }
          that.userInfo = res.data.data
          that.cardNum = res.data.data.userCard.cardNum
        }
    })
  },
  methods: {
    // 获取用户信息
		getUserInfo() {
			const	businessId = this.businessId
			return getUserInfo({ businessId })
    },
    // 发送验证码
    sendSms() {
      const that = this
      const { phone } = this
      if(!this.msgSendStatus){
				return
			}
      if(phone.length < 1){
        this.$toast('请填写手机号')
        return
      }
      const reg = /^1[3-9]\d{9}$/g;
      const result = reg.test(phone)
      if(!result){
        this.$toast('手机号格式不规范')
        return
      }
			return sendVerifyCode({ phone })
      .then(res => {
        if(res.data.code != '200'){
					throw res.data.msg
				}
				if(res.data.code == '200'){
					that.$toast(res.data.msg)
					let time = 60
					that.msgSendStatus = false,
					that.msgSendTxt = time + '秒再试'
					
					let timer = setInterval(function(){
						if(time <= 0){
							that.msgSendStatus = true,
							that.msgSendTxt = '获取验证码'
							
							clearInterval(timer)
							return false
						}
						that.msgSendTxt = time + '秒再试'
						that.msgSendStatus = false
						time--
					},1000)
				}
      })
    },
    // 更新用户手机号
    updatePhone() {
      const that = this
      const { cardNum, phone, verifyCode, businessId } = this
      if(cardNum.length < 1){
        this.$toast('卡号获取不到')
        return
      }
      if(phone.length < 1){
        this.$toast('请填写手机号')
        return
      }
      const reg = /^1[3-9]\d{9}$/g;
      const result = reg.test(phone)
      if(!result){
        this.$toast('手机号格式不规范')
        return
      }
      if(verifyCode.length < 1){
        this.$toast('请填写验证码')
        return
      }
      
      const token = getToken()
      if(!token) {
        this.$toast('token获取失败')
        return
      }
      bindPhone({ cardNum, phone, verifyCode, businessId, token })
      .then(res => {
        if(res.data.code != '200'){
          throw res.data.msg
        }
        if(res.data.code == '200'){
          this.$dialog.confirm({
            message: '绑定成功，是否立即预约？',
          })
          .then(() => {
            that.$router.back()
          }).catch(() => {
            that.$router.back()
          })
        }
      })
      .catch(err => {
        that.$toast(err)
      })
    },
    // input失焦内容顶起BUG
    blurTo(){
      window.scrollTo(0,0)
    }
  }
}
</script>
<style scoped>
.orderForm {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-position: 0 0;
  background-repeat: no-repeat;
  background-size: 100% 480px;
  overflow-y: auto;
}

.pageTitle {
  margin: 169px auto 80px auto;
  width: calc(100% - 80px);
  font-size: 60px;
  font-weight: bold;
  color: #FFF;
}

.form {
  margin: 0px auto 80px auto;
  box-shadow:0px 0px 40px 0px rgba(0,0,0,0.06);
  border-radius:20px;
  padding: 60px;
  width: calc(100% - 180px);
  background: #FFF;
}
.form .item {
  margin-bottom: 67px;
}
.form .label {
  width: 100%;
  height: 60px;
  font-size: 32px;
  font-weight: bold;
}

.form .text {
  border-bottom: 1px solid #E0E0E0!important;
  width: 100%;
  height: 100px;
  line-height: 100px;
}
.form .text.message {
  display: flex;
  align-items: center;
}
.form .text input {
  display: block;
  padding: 0!important;
  width: 100%;
  height: 99px;
}
.form .text.message input {
  flex: 0 0 calc(100% - 175px);
  padding: 0!important;
  width: calc(100% - 175px);
  height: 98px;
}
.form .text.message input::-webkit-input-placeholder {
  font-size: 28px;
  color: #CCC!important;
}
.form .text.message .message-btn {
  display: inline-block;
  flex: 0 0 175px;
  border-radius: 29px;
  border: 2px solid #00BC7A;
  width: 170px;
  height: 58px;
  font-size: 24px;
  line-height: 58px;
  text-align: center;
  color: #00BC7A;
}
.form .bottom {
  box-shadow:0px 20px 20px 0px rgba(63,239,170,0.2);
  border-radius:10px;
  width: 100%;
  height:88px;
  font-size: 32px;
  font-weight: bold;
  line-height: 88px;
  text-align: center;
  color: #FFF;
  background:linear-gradient(135deg,rgba(82,211,131,1) 0%,rgba(0,188,122,1) 100%);
}



::-webkit-input-placeholder { /* WebKit, Blink, Edge */
  font-size: 28px;
  color:#CCC;
}
:-moz-placeholder { /* Mozilla Firefox 4 ~ 18 */
  font-size: 28px;
  color:#CCC;
}
::-moz-placeholder { /* Mozilla Firefox 19+ */
  font-size: 28px;
  color:#CCC;
}
:-ms-input-placeholder { /* Internet Explorer 10 ~ 11 */
  font-size: 28px;
  color:#CCC;
}
::-ms-input-placeholder { /* Microsoft Edge */
  font-size: 28px;
  color:#CCC;
}

::placeholder { /* 大部分现代浏览器 */
  font-size: 28px;
  color:#CCC;
}
</style>